import { useEffect, useMemo, useState } from "react";
import "./AdminExportsModule.scss";
import { toast } from "react-toastify";
import {
  deleteStatisticsExport,
  listStatisticsExports,
} from "../../../api/statistics/statistics";

interface AdminExportsModuleProps {
  refreshKey: number;
}

const AdminExportsModule = ({ refreshKey }: AdminExportsModuleProps) => {
  const [exportedFiles, setExportedFiles] = useState<any[]>([]);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const fetchExportedFiles = async () => {
    const loadingToast = toast.loading("Hämtar exporterade filer...");
    try {
      // Replace with actual API call to fetch exported files
      const response = await listStatisticsExports();
      toast.info("Senaste hämtat");
      setExportedFiles(response.items);
    } catch (error) {
      toast.error("Kunde inte hämta exporterade filer.");
    } finally {
      toast.dismiss(loadingToast);
    }
  };

  useEffect(() => {
    fetchExportedFiles();
  }, [refreshKey]);

  const deleteExportedFile = async (fileId: string) => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      // Replace with actual API call to delete the exported file
      const response = await deleteStatisticsExport(fileId);
      if (response) {
        setExportedFiles((prevFiles) =>
          prevFiles.filter((file) => file.id !== fileId),
        );
        toast.success("Exporterad fil borttagen.");
      }
    } catch (error) {
      toast.error("Kunde inte ta bort den exporterade filen.");
    } finally {
      setIsDeleting(false);
    }
  };
  return (
    <div className="admin-exports-module-container">
      <div className="admin-exports-module export-table-section">
        <div className="export-table-header">
          <div className="text-m">Exporterade filer</div>
        </div>

        <table className="export-table">
          <thead>
            <tr>
              <th>Namn</th>
              <th>Skapad</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {exportedFiles &&
              exportedFiles.map((file) => (
                <tr key={file.id}>
                  <td title={file.fileName}>
                    <div className="export-table-flexer">
                      <i className="fa-regular fa-file " />
                      {file.fileName.replace(".xlsx", "").replace(/_/g, " ")}
                    </div>
                  </td>
                  <td>{new Date(file.lastModified).toLocaleString()}</td>
                  <td>
                    <a href={file.downloadUrl} className=" " download>
                      <i className="fa-regular fa-file-arrow-down"></i>
                    </a>
                  </td>
                  <td>
                    <div
                      onClick={() => {
                        if (!isDeleting) deleteExportedFile(file.id);
                      }}
                      className="text-danger pointer"
                    >
                      <i className="fa-regular fa-trash-can"></i>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="occupancy-spacer" />
    </div>
  );
};
export default AdminExportsModule;
